import React, { useRef, useState, useEffect, useContext, Fragment } from "react";

//imagenes
import calendar from "../assets/img/calendar.svg";
import campos1 from "../assets/img/campos.svg";
import filtros1 from "../assets/img/filtros.svg";
import agregaciones_ico from "../assets/img/agregaciones.svg";
import exportacion from "../assets/img/exportacion.svg";
// import aspa2 from "../assets/img/aspa2.png";
import carga from "../assets/img/carga.gif";
import cargaticket from "../assets/img/cargaticket.svg";
import uploadimg from "../assets/img/uploadimg.svg";
import uploadimg2 from "../assets/img/uploadimg3.svg";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import Calendario from "./JS/Calendario";
import clickOut from "../assets/js/clickOut";
import ModalCampos from "./modales/ModalCampos";
import ModalPorTipo from "./modales/ModalPorTipo";
import ConexContext from "../context/ConexContext";
import ModalAgrega from './modales/ModalAgregaciones';
import ModalFiltro from './modales/ModalFiltros';
import ModalSubirImagenes from "./modales/ModalSubirImagenes";
import { ExportCSV } from './JS/ExportCSV';


//Contexto


const Listado = ({ setmensaje2 }) => {
	// let navigate = useNavigate();
	// CONEX
	const { peticion, getToken } = useContext(ConexContext);

	// STATE
	const [calendView, setCalendView] = useState("hide");//Calendario para Fecha Inicial
	const [calendView2, setCalendView2] = useState("hide");//Calendario para Fecha Final
	const [modalCampos, setModalCampos] = useState(false);//Modal para el apartado "campos"
	const [modalPorTipo, setModalPorTipo] = useState(false);//Modal para el apartado "PorTipo"
	const [modalAgrega, setModalAgrega] = useState(false);//Modal para el apartado "Agregaciones"
	const [modalFiltro, setModalFiltro] = useState(false);//Modal para el apartado "Filtro"
	const [modalSubirImagnes, setModalSubirImagnes] = useState(false);//Modal para el apartado "Subir Imagenes"
	const [modalGenerarCSV, setModalGenerarCSV] = useState(false);
	const [CopyConf, setCopyConf] = useState(null); //configuracion general de la plantilla
	const [campos, setCampos] = useState(getCampos());//contendrán los campos y demas
	const [agregaciones, setAgregaciones] = useState(getagregaciones());//contendrán las agregaciones y demas
	const [filtros, setFiltros] = useState(getfiltros());//contendrán los filtros y demas
	const [date1, setDate1] = useState(null);//Fecha Inicial
	const [date2, setDate2] = useState(null);//Fecha Final
	const [Confs, setConfs] = useState(null)//configuracion general de los ficheros
	const [Fila, setFila] = useState(""); // DATOS DE FILA
	const [Resultados, setResultados] = useState(0);
	const [Columnas, setColumnas] = useState([]);
	const [Nivel, setNivel] = useState(0);
	const [Cargando, setCargando] = useState(true);//Modal para el apartado "Agregaciones"
	const [Datos_generales, setDatos_generales] = useState([]);// DATOS GENERALES ORDENADOS
	const [fechaMaxCal, setFechaMaxCal] = useState(null); //fecha máxima para el calendario
	const [fechaMinCal, setFechaMinCal] = useState(null); //fecha mínima para el calendario

	// REF
	const divCalendar = useRef(); //ref para ocultar el calendario


	// VARIABLES
	let archivo = require('../config/campos.json');
	let archivo_agregaciones = require('../config/agregaciones.json');
	let vector_clases = ["subfila subfila0", "subfila", "subfila_all"];
	let vector_clases_tabla = ["tabladatos", "cont_subfila", "cont_subfila2"];



	//Effec inicial. Carga los campos por defecto
	useEffect(() => {
		if (Confs) return;
		const Agregaciones_campos_confs = () => {
			let copConfs = {
				agregaciones: [],
				campos: [],
				filtros: [],
				filtros_: {
					"nexo":"Y",
					"filtros_":[
					]
				}
			}
			//ahora habrá que borrar los campos del fichero y reasignar los que vayan a tener un número ahora superior
			let agregaciones_copy = []// los metermos así para que no den problemas
			let campos_copy = []// los metermos así para que no den problemas
			let filtros_copy = []// los metermos así para que no den problemas
			agregaciones && Object.keys(agregaciones).forEach(id => {
				if (agregaciones[id].seleccionado === true) {
					agregaciones_copy.push(agregaciones[id].nombre);
				}
			})
			campos && Object.keys(campos).forEach(id => {
				if (campos[id].seleccionado === true) {
					campos_copy.push(campos[id].nombre);
				}
			})
			filtros && Object.keys(filtros).forEach(id => {
				if (filtros[id].seleccionado === true) {
					filtros_copy.push(filtros[id].nombre);
				}
			})
			copConfs.filtros = filtros_copy;
			copConfs.agregaciones = agregaciones_copy;
			copConfs.campos = campos_copy;
			// luego habrá que hacer lo mismo con los filtros
			setConfs(copConfs);
		}
		if (!Confs) {
			Agregaciones_campos_confs();
		}

	}, [Confs, agregaciones, campos, filtros])


	//Effec para el calculo de la fecha dependiendo de las operaciones de usuario
	useEffect(() => {
		const ultima_fecha = async () => {
			let res = await peticion(`/ultimafecha`, { method: 'POST' });
			if (res?.estado ?? true) return
			if (res["res"].length > 0) {
				setDate1(fechaCambio((parseInt(res["res"][0]["X.fecha_ope"]) - 99)));
				setDate2(fechaCambio((parseInt(res["res"][0]["X.fecha_ope"]) + 1)));
				setFechaMaxCal(fechaCambio((parseInt(res["res"][0]["X.fecha_ope"]) + 1)));
				setFechaMinCal(fechaCambio((parseInt(res["res2"][0]["X.fecha_ope"]))));
			} else {
				let fecha = new Date()
				setDate2(fecha);
				let year = fecha.getFullYear().toString().padStart(4, 0)
				let month = (fecha.getMonth() - 1).toString().padStart(2, 0);
				let day = fecha.getDate().toString().padStart(2, 0);
				let fecha2 = new Date(`${year}/${month}/${day}`);
				setDate1(fecha2);
			}
		}

		if (!getToken()) return;
		ultima_fecha();
	}, [peticion, getToken])

	//Effec para coger los datos generales para mostrar en la tabla
	useEffect(() => {

		setCalendView("hide");
		setCalendView2("hide");
		async function datos_generales() {
			setCargando(true);
			try {
				let res_general = await peticion(`/resultadosGenerales?fechainicio=${fechaDB(date1)}&fechafin=${fechaDB(date2)}`, { method: 'POST', json: Confs });
				if (res_general?.estado ?? true) return
				// setDatos_generales(res_general["ordenados"]);
				setDatos_generales(res_general["Resultados"]);
			} finally {
				setCargando(false);
			}
		}
		if (!date1 | !date2 | !Confs) return;
		datos_generales();



	}, [date1, date2, Confs, peticion])


	// FUNCIONES
	// devuelve la fecha en formato date de un valor aaaammdd
	function fechaCambio(date) {
		let year = date.toString().substring(4, 0);
		let month = date.toString().substring(6, 4);
		let day = date.toString().substring(9, 6);
		date = new Date(`${year}/${month}/${day}`);
		return date;
	}
	// devuelve la fecha en formato dd/mm/aaaa
	function fechaEsp(date) {
		let s = date.getDate().toString().padStart(2, 0);
		s += "/" + (date.getMonth() + 1).toString().padStart(2, 0);
		s += "/" + date.getFullYear().toString().padStart(4, 0);
		return s;
	}
	// devuelve la fecha en formato aaaammdd
	function fechaDB(date) {
		let s = date.getFullYear().toString().padStart(4, 0);
		s += (date.getMonth() + 1).toString().padStart(2, 0);
		s += date.getDate().toString().padStart(2, 0);
		return s;
	}
	//cierra el calendario
	clickOut(divCalendar, () => {
		setCalendView("hide");
		setCalendView2("hide");
	});
	// devuelve la fecha en formato object (para el calendar)
	function fechaObjet(date) {
		if (!date) return;
		return {
			day: date.getDate(),
			month: date.getMonth() + 1,
			year: date.getFullYear(),
		};
	}
	// devuelve los campos pero con valores por defecto
	function getCampos() {
		let camp = require('../config/campos.json');
		//valores por defecto
		Object.keys(camp).forEach(id => {
			if (camp[id].campo === undefined) camp[id].campo = true;
			camp[id].tipo = "campo"
		})
		return (camp)
	}
	// devuelve las agregaciones pero con valores por defecto
	function getagregaciones() {
		let agrega = require('../config/agregaciones.json');
		//valores por defecto
		Object.keys(agrega).forEach(id => {
			if (agrega[id].agregaciones === undefined) agrega[id].agregaciones = true;
			agrega[id].tipo = "agregaciones"
		})
		return (agrega)
	}
	// devuelve los filtros pero con valores por defecto
	function getfiltros() {
		let filtro = require('../config/filtros.json');
		//valores por defecto
		Object.keys(filtro).forEach(id => {
			if (filtro[id].filtros === undefined) filtro[id].filtros = true;
			filtro[id].tipo = "filtros"
		})
		return (filtro)
	}
	function getNivelFila(fila) {
		if (!fila) return 0;
		let nivel = parseInt(fila.nivel, 10);
		if (Number.isNaN(nivel)) nivel = parseInt(fila.Nivel, 10);
		return Number.isNaN(nivel) ? 0 : nivel;
	}
	const NivelSuperiorVisible = (Datos_generales && Datos_generales.length > 0)
		? Datos_generales.reduce((nivelMinimo, fila) => {
			let nivelFila = getNivelFila(fila);
			return nivelFila < nivelMinimo ? nivelFila : nivelMinimo;
		}, getNivelFila(Datos_generales[0]))
		: 0;
	const TotalesNivelSuperior = Datos_generales?.reduce((acum, fila) => {
		if (getNivelFila(fila) !== NivelSuperiorVisible) return acum;
		let importe = Number(fila?.Importe);
		let operaciones = Number(fila?.Operaciones);
		acum.Importe += Number.isFinite(importe) ? importe : 0;
		acum.Operaciones += Number.isFinite(operaciones) ? operaciones : 0;
		return acum;
	}, { Importe: 0, Operaciones: 0 }) ?? { Importe: 0, Operaciones: 0 };

	// RETURN
	if (!date1 | !campos | !date2 | !Datos_generales)
		return <h1 className="cargando">Cargando...</h1>
	else
		return (
			<>
				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 cont_datos">

					<div className="col-xs-12 nopadding subirimgmovil">

						<button onClick={() => {
							setModalSubirImagnes(true);
						}
						}
						>Subir imagen<span><img src={uploadimg2} alt="" /></span></button>

					</div>

					<div className="campos">
						<div ref={divCalendar} className="cont_fechas2">
							<div className="col-xs-6">
								<p>De</p>
								{ }
								<div
									onClick={() => {
										setCalendView2("hide");
										setCalendView("view");
									}}
									className="arreglo"
								>
									<img src={calendar} alt="" />
									<p className="" id="">
										{fechaEsp(date1)}
									</p>
									<Calendario
										date={date1}
										setDate={setDate1}
										calendView={calendView}
										setCalendView={setCalendView}
										maximumDate={fechaObjet(date2)}
										minimumDate={fechaObjet(fechaMinCal)}
									/>
								</div>
							</div>
							<div className="col-xs-6">
								<p>Hasta</p>
								{ }
								<div
									onClick={() => {
										setCalendView("hide");
										setCalendView2("view");
									}}
									className="arreglo"
								>
									<img src={calendar} alt="" />
									<p className="" id="">
										{fechaEsp(date2)}
									</p>
									<Calendario
										date={date2}
										setDate={setDate2}
										calendView={calendView2}
										setCalendView={setCalendView2}
										minimumDate={fechaObjet(date1)}
										maximumDate={fechaObjet(fechaMaxCal)}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="campos nopadding">
						<ul className="lista_enlaces">
							<li>
								<button
									className="botonnav"
									onClick={() => {
										setModalCampos(true);
									}}
								>
									Datos  <img src={campos1} alt="" />
								</button>
							</li>
							<ModalCampos
								show={modalCampos}
								conf={CopyConf}
								campos={campos}
								setCampos={setCampos}
								setConf={setCopyConf}
								onHide={() => setModalCampos(false)}
								Confs={Confs}
								setConfs={setConfs}
								setCargando={setCargando}
							/>
							<li>
								<button
									className="botonnav"
									onClick={() => {
										setModalFiltro(true);
									}}
								>
									Filtros  <img src={filtros1} alt="" />
								</button>
							</li>
							<ModalFiltro
								show={modalFiltro}
								onHide={() => setModalFiltro(false)}
								setConf={setCopyConf}
								filtros={filtros}
								setFiltros={setFiltros}
								Confs={Confs}
								setConfs={setConfs}
								date1={date1}
								date2={date2}
								fechaDB={fechaDB}
							/>
							<li>
								<button
									className="botonnav"
									onClick={() => {
										setModalAgrega(true);
									}}
								>
									Agrupar Por  <img src={agregaciones_ico} alt="" />
								</button>
							</li>
							<ModalAgrega
								show={modalAgrega}
								agregaciones={agregaciones}
								setAgregaciones={setAgregaciones}
								Confs={Confs}
								setConfs={setConfs}
								setCargando={setCargando}
								onHide={() => setModalAgrega(false)}
							/>
							<li>
								<ExportCSV
									show={modalGenerarCSV}
									onHide={() => setModalGenerarCSV(false)}
									confs={Confs}
									date1={date1}
									date2={date2}
								/>
								<button className="botonnav" onClick={() => { setModalGenerarCSV(true) }}>
									Exportar <img src={exportacion} alt="" />
								</button>
							</li>
							<li>
								<button
									className="botonnav"
									onClick={() => {
										setModalSubirImagnes(true);
									}}
								>
									Subir imagenes  <img src={uploadimg} alt="" />
								</button>
							</li>
							<ModalSubirImagenes
								show={modalSubirImagnes}
								onHide={() => setModalSubirImagnes(false)}
								auxiliar={false}
							/>
						</ul>
					</div>
				</div>

				<div className="col-xs-12 navfiltros">
					<div className="navfiltros_fechas">
						Del <strong>{fechaEsp(date1)}</strong> al{" "}
						<strong>{fechaEsp(date2)}</strong>
					</div>

					<div className="navfiltros_applied">
						<p>Filtros aplicados:</p>
						<ul>
							{/* IMPLEMENTAR VISUALIZACION DE FILTROS NUEVA */}
							{/* {
								Confs.filtros_ && Object.keys(Confs.filtros_).map(
									(elem, i) =>
									(
										<Fragment key={elem + i}>
											<li key={i}>
												<div className="info1">
												{Confs.filtros_[elem]["titulo_"]} 
												{Confs.filtros_[elem]["oper_"]} 
												{(Confs.filtros_[elem]["tipo_"] === "moneda" || Confs.filtros_[elem]["tipo_"] === "numero")? (Confs.filtros_[elem]["valor_"]) : (Confs.filtros_[elem]["titulo"])}
												</div>
												<img
													src={aspa2}
													className="aspa"
													alt=""
													onClick={() => {
														let aux = { ...Confs };
														aux.filtros_ = aux.filtros_.filter(function (i) { return i !== Confs.filtros_[elem] }); // filtramos
														setConfs(aux);
													}}
													style={{ cursor: 'pointer' }}
												/>
											</li>
											<li key={i + 1} className="Y_O_filtro">
												{Confs.filtros_.length > 1 && i < Confs.filtros_.length - 1 && Confs.filtros_[elem]["nexo_"]}
											</li>
										</Fragment>

									)
								)
							} */}
							{Confs.filtros_ && Confs.filtros_.filtros_ && 
								Confs.filtros_.filtros_.map((elem1, i) => (
									<Fragment key={i}>
										{i !== 0 && (
											<button className="y_o" 
											style={{ cursor: "pointer" }}
											onClick={() => {
												setModalFiltro(true);
											}}>
												<span>{Confs.filtros_.nexo}</span>
											</button>
										)}
										<li
											className="filtro"
											onClick={() => {
												setModalFiltro(true);
											}}>
											<div className="filtro_added_oy flex-row">
												{/* <div className="insert_filtro text-center">
													Agrupación de filtro
												</div> */}
												{/* <div className="alineaflex info2"> */}
													{elem1.filtros_.map((elem2, j) => (
														<Fragment key={j}>
															<ul>
																<li
																	style={{ cursor: "pointer" }}
																	className="info2">
																	{elem2["titulo_"]} 
																	{elem2["oper_"]} 
																	{(elem2["tipo_"] === "moneda" || elem2["tipo_"] === "numero")? (elem2["valor_"]) : (elem2["titulo"])}
																</li>
															</ul>
															{elem1.filtros_.length - 1 !== j && (
																<button className="y_o" 
																style={{ cursor: "pointer" }}
																onClick={() => {
																	setModalFiltro(true);
																}}>
																	<span>{elem1.nexo}</span>
																</button>
															)}
														</Fragment>
													))}
												{/* </div> */}
											</div>
										</li>
									</Fragment>
								))}
						</ul>
					</div>
				</div>

				<div className="col-xs-12 tabla puedehaberhasta4" >
					<div className="col-xs-12 cabeceratabla">
						<div className="col-xs-12 cont_cabeceratabla">

							<table>
								<tbody>
									<tr>
										<td
											className=""
										>
											{
												Confs.agregaciones && Object.keys(Confs.agregaciones).map(
													(elem, i) =>
													(
														<Fragment key={i}>

															{

																<Fragment key={i + elem}>


																	<div className="contagregatd"><span className={"icontabla_" + archivo_agregaciones[Confs.agregaciones[elem]].Titulo}></span><p>{archivo_agregaciones[Confs.agregaciones[elem]].Titulo}</p><i className="fa-solid fa-chevron-right"></i></div>

																</Fragment>
															}
														</Fragment>
													)
												)
											}
										</td>
										{
											Confs.campos && Object.keys(Confs.campos).map(
												(elem, i) =>
												(
													<Fragment key={i}>
														{
															<td
																className="txtright"
															>
																{archivo[Confs.campos[elem]].Titulo}
															</td>
														}
													</Fragment>
												)
											)
										}
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<div className="col-xs-12 cont_tabladatos">
						{!Cargando ? (
							<>
								{Confs.agregaciones.length > 0 &&
									Datos_generales && Datos_generales.map(
										(elem, i) => (
											<Fragment key={i}>
												<table className={Confs.agregaciones.length === 1 ? (vector_clases_tabla[elem.Nivel < 3 ? (elem.Nivel) : (2)]) : (elem.nivel < 3 ? (vector_clases_tabla[elem.nivel]) : (vector_clases_tabla[2]))} width="auto" border="0" cellSpacing="0" cellPadding="0" style={{ marginLeft: `${elem.Nivel ? (elem.Nivel) : (elem.nivel)}%`, width: `${100 - (elem.Nivel ? (elem.Nivel) : (elem.nivel))}%` }}>
													<tbody>
														<tr className={Confs.agregaciones.length === 1 ? (vector_clases[elem.Nivel < 3 ? (elem.Nivel) : (2)]) : (elem.nivel < 3 ? (vector_clases[elem.nivel]) : (vector_clases[2]))}
															onClick={() => {
																// setFila(Confs.agregaciones.length===1 ? (elem[Confs.agregaciones[0]]):(elem.nombre));
																let nombre_fila = Confs.agregaciones.length === 1 ? (Confs.agregaciones[0] === "Departamento" ? (elem["Nombre_Departamento"]) : (Confs.agregaciones[0] === "Usuario" ? (elem["Nombre_Usuario"]) : (Confs.agregaciones[0] === "Empresa" ? (elem["Nombre_Empresa"]) : (Confs.agregaciones[0] === "Entidad" ? (elem["Nombre_Entidad"]) : (elem[Confs.agregaciones[0]]))))) : (elem.Nombre_Departamento ? (elem.Nombre_Departamento) : (elem.Nombre_Usuario ? (elem.Nombre_Usuario) : (elem.Nombre_Empresa ? (elem.Nombre_Empresa) : (elem.Nombre_Entidad ? (elem.Nombre_Entidad) : (elem.nombre)))))
																if (nombre_fila) {
																	setFila(nombre_fila)
																} else {
																	setFila("Sin Identificar")
																}
																let auxiliar2 = [];
																if (Confs.agregaciones.length === 1) {
																	auxiliar2.push(elem[Confs.agregaciones[0]])
																} else {
																	let spliter = elem["columnas"].split("; ")
																	spliter.forEach((el) => {
																		auxiliar2.push(el.split("=")[1])
																	})
																}
																if (Confs.agregaciones.length > 1) {
																	// const comparar = (element) => element === elem.agregacion;
																	// let nivel_ficticio=Confs.agregaciones.findIndex(comparar);
																	// setNivel(nivel_ficticio+1);
																	setNivel(elem.nivel + 1)
																} else {
																	setNivel(1);
																}
																setColumnas(auxiliar2);
																setResultados(elem["Operaciones"]);
																setModalPorTipo(true);
															}}
															style={{ cursor: 'pointer' }}
														>
															<td className="solomovil"><button className="cargaticket"><img src={cargaticket} alt="carga ticket" /></button></td>

															<td className={"numeros2" + i}><div><span className={"icontabla_" + archivo_agregaciones[Confs.agregaciones.length === 1 ? (Confs.agregaciones[0]) : (elem.agregacion)].Titulo}></span>{Confs.agregaciones.length === 1 ? (Confs.agregaciones[0] === "Departamento" ? (elem["Nombre_Departamento"]) : (Confs.agregaciones[0] === "Usuario" ? (elem["Nombre_Usuario"]) : (Confs.agregaciones[0] === "Empresa" ? (elem["Nombre_Empresa"]) : (Confs.agregaciones[0] === "Entidad" ? (elem["Nombre_Entidad"]) : (elem[Confs.agregaciones[0]]))))) : (elem.Nombre_Departamento ? (elem.Nombre_Departamento) : (elem.Nombre_Usuario ? (elem.Nombre_Usuario) : (elem.Nombre_Empresa ? (elem.Nombre_Empresa) : (elem.Nombre_Entidad ? (elem.Nombre_Entidad) : (elem.nombre)))))}</div></td>

															{Confs.campos && Confs.campos.map(
																(id, t) =>
																(
																	<Fragment key={t}>
																		{
																			id === "Importe" &&
																			<td className="numeros"><div style={{ width: `${100 - ((t === Confs.campos.length - 3 ? 2 * (elem.Nivel ? (elem.Nivel) : (elem.nivel)) : t === Confs.campos.length - 2 ? 1 * (elem.Nivel ? (elem.Nivel) : (elem.nivel)) : t === Confs.campos.length - 1 ? 0 : 0))}%` }}>{Confs.agregaciones.length === 1 ? (elem[id] + "€") : (elem[id].toFixed(2) + "€")}</div></td>
																		}
																		{
																			id === "Operaciones" &&
																			<td className="numeros"><div style={{ width: `${100 - ((t === Confs.campos.length - 3 ? 2 * (elem.Nivel ? (elem.Nivel) : (elem.nivel)) : t === Confs.campos.length - 2 ? 1 * (elem.Nivel ? (elem.Nivel) : (elem.nivel)) : t === Confs.campos.length - 1 ? 0 : 0))}%` }}>{elem[id]}{<p className="solomovil">{elem[id] === 1 ? ("operación") : ("operaciones")}</p>}</div></td>
																		}
																		{
																			id === "Varemo" &&
																			<td className="numeros"><div style={{ width: `${100 - ((t === Confs.campos.length - 3 ? 2 * (elem.Nivel ? (elem.Nivel) : (elem.nivel)) : t === Confs.campos.length - 2 ? 1 * (elem.Nivel ? (elem.Nivel) : (elem.nivel)) : t === Confs.campos.length - 1 ? 0 : 0))}%` }}>{Confs.agregaciones.length === 1 ? (elem[id] === null ? ((0.00).toString() + "%") : (elem[id] + "%")) : (elem[id] === null ? ((0.00).toString() + "%") : (elem[id].toFixed(2) + "%"))}</div></td>
																		}
																	</Fragment>
																)
															)
															}
														</tr>
													</tbody>
												</table>
											</Fragment>
										))}
								{Confs.agregaciones.length > 0 && Datos_generales && Datos_generales.length > 0 && (
									<table className="tabladatos" width="auto" border="0" cellSpacing="0" cellPadding="0" style={{ marginLeft: "0%", width: "100%" }}>
										<tbody>
											<tr className="subfila0 filatotal">
												<td className="solomovil"></td>
												<td className="numeros2"><div><strong>Total</strong></div></td>
												{Confs.campos && Confs.campos.map((id, t) => (
													<td className="numeros" key={`total-${id}-${t}`}><div>{id === "Importe" ? `${TotalesNivelSuperior.Importe.toFixed(2)}€` : id === "Operaciones" ? Math.round(TotalesNivelSuperior.Operaciones) : ""}</div></td>
												))}
											</tr>
										</tbody>
									</table>
								)}
							</>
						) : (
							<div className="col-xs-12 preloaderkpi">
								Cargando...<img src={carga} style={{ width: '10px', height: '10px' }} alt='Cargando' />
							</div>
						)}
						<ModalPorTipo
							show={modalPorTipo}
							onHide={() => setModalPorTipo(false)}
							Fila={Fila}
							date1={date1}
							date2={date2}
							Confs={Confs}
							Resultados={Resultados}
							Columnas={Columnas}
							Nivel={Nivel}
							setConfs={setConfs}
						/>
					</div>
				</div>
			</>
		);
};

export default Listado;
